<template>
  <div class="p-4">
    <el-button class="float-right" type="primary" icon="el-icon-plus" circle size="small"
               @click="openNewRoleDialog()"></el-button>
    <el-table
      :data="roles.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="Name"
        sortable>
      </el-table-column>
      <el-table-column
        prop="status"
        label="Enabled?">
        <template slot-scope="scope">
          <span v-if="scope.row.status === true"><el-tag size="small" type="success">Yes</el-tag></span>
          <span v-else><el-tag size="small" type="danger">No</el-tag></span>
        </template>
      </el-table-column>
      <el-table-column align="right" fixed="right">
        <template slot="header" slot-scope="scope">
          <el-input
            v-model="search"
            size="mini"
            placeholder="Type to search"/>
        </template>
        <template slot-scope="scope">
          <el-button @click="updateRole(scope.row)" type="text" size="small">
            <i class="text-xl el-icon-edit-outline mr-4"></i>
          </el-button>
          <el-button @click="deleteRole(scope.row.id)" type="text" size="small">
            <i class="text-xl text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <RoleUpdateForm />
    <NewRoleForm />
  </div>
</template>

<script>
import { flatMap } from 'lodash';
import RoleUpdateForm from './_includes/RoleUpdateForm.vue';
import NewRoleForm from './_includes/NewRoleForm.vue';

export default {
  name: 'Roles',
  components: {
    RoleUpdateForm,
    NewRoleForm,
  },
  data() {
    return {
      search: '',
    };
  },
  computed: {
    roles() {
      return flatMap(this.$store.state.SecurityModule.Role.roles);
    },
  },
  methods: {
    openNewRoleDialog() {
      this.$modal.show('new-role-modal');
    },
    updateRole(role) {
      this.$modal.show('update-role-modal');
      this.$store.commit('SecurityModule/Role/setProperty', { property: 'role', payload: role });
    },
    deleteRole(roleId) {
      this.$confirm('Are you sure you want to delete this role?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('SecurityModule/Role/deleteRole', { roleId });
          this.$notify.success({
            title: 'Success',
            message: 'Role has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
